import { Link } from 'react-router-dom';
import { ScanFace } from 'lucide-react';
import { PLATFORM_NAME } from '../lib/constants';

export const Logo = ({ to = '/', testId = 'logo-link', light = false }) => (
  <Link to={to} className="inline-flex items-center gap-2.5 group" data-testid={testId}>
    <span className="w-9 h-9 bg-cyan text-ink flex items-center justify-center border-2 border-cyan shadow-sm group-hover:translate-x-[1px] group-hover:translate-y-[1px] group-hover:shadow-sm transition-all">
      <ScanFace className="w-5 h-5" strokeWidth={2.5} />
    </span>
    <span className={`font-display font-bold uppercase tracking-tight text-lg ${light ? 'text-ink' : 'text-white'}`}>{PLATFORM_NAME}</span>
  </Link>
);
